"use client"

import { useState, useContext } from "react"
import { Link, useNavigate } from "react-router-dom"
import { AuthContext } from "../context/AuthContext"
import { useLanguage } from "../context/LanguageContext"
import { useNotification } from "../context/NotificationContext"
import LanguageSwitcher from "../components/common/LanguageSwitcher"
import "./Login.css"

const Login = () => {
  const { login } = useContext(AuthContext)
  const { t, direction } = useLanguage()
  const { showNotification } = useNotification()
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })

  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const { email, password } = formData

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
    setErrorMessage("")
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      setLoading(true);
      const result = await login(email, password);
    
      if (result.success) {
        navigate("/dashboard");
        showNotification(t("Login successful"), "success");
      } else {
        setErrorMessage(t("You entered wrong email or password/ verify email address"));
        showNotification(result.error || t("Invalid credentials"), "error");
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(t("Something went wrong"));
      showNotification(t("Something went wrong"), "error");
    } finally {
      setLoading(false);
    }
    
  }

  return (
    <div className="login-container" dir={direction}>
      <div className="login-card">
        <div className="card-header">
          <h1>{t("Login")}</h1>
          <p>{t("Sign in to your account")}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">{t("Email Address")}</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={handleChange}
              placeholder={t("Enter your email")}
              required
            />
          </div>

          <div className="form-group password-group">
            <label htmlFor="password">{t("Password")}</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={password}
                onChange={handleChange}
                placeholder={t("Enter your password")}
                required
              />
              <span
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️" : "🙈"}
              </span>
            </div>
          </div>

          {errorMessage && (
            <div className="error-message">{errorMessage}</div>
          )}

          <div className="form-options">
            <Link to="/forgot-password" className="forgot-password-link">
              {t("Forgot Password?")}
            </Link>
          </div>

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? t("Signing in...") : t("Sign In")}
          </button>

          <div className="language-selector-container">
            <span>{t("Language")}:</span>
            <LanguageSwitcher />
          </div>

          <div className="register-link">
            {t("Don't have an account?")} <Link to="/register">{t("Register")}</Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Login
